import React from 'react';
import { Card, Stack, TextField, MenuItem, Button, Typography, Box } from '@mui/material';
import Iconify from '../../iconify/Iconify';

export default function DashboardFilters({ filters, employeeOptions, onChange, onRefresh, refreshing }) {
  return (
    <Card
      sx={{
        p: 2.2,
        mb: 3,
        borderRadius: 3,
        border: '1px solid',
        borderColor: 'rgba(25,118,210,0.14)',
        background: 'linear-gradient(135deg, rgba(255,255,255,0.95), rgba(246,251,255,0.85))',
        boxShadow: '0 10px 22px rgba(16, 24, 40, 0.05)',
      }}
    >
      <Stack spacing={1.5}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Box
            sx={{
              width: 28,
              height: 28,
              borderRadius: '50%',
              display: 'grid',
              placeItems: 'center',
              bgcolor: 'rgba(25,118,210,0.12)',
              color: 'primary.main',
            }}
          >
            <Iconify icon="solar:settings-bold-duotone" width={16} />
          </Box>
          <Typography variant="subtitle1" sx={{ fontWeight: 700, fontSize: { xs: '0.95rem', md: '1rem' } }}>
            Global Filters
          </Typography>
        </Stack>

        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={2}
          alignItems={{ xs: 'stretch', md: 'center' }}
        >
          <TextField
            label="From"
            type="date"
            name="from"
            size="small"
            fullWidth
            value={filters.from}
            onChange={onChange}
            InputLabelProps={{ shrink: true }}
            sx={{ bgcolor: 'background.paper' }}
          />

          <TextField
            label="To"
            type="date"
            name="to"
            size="small"
            fullWidth
            value={filters.to}
            onChange={onChange}
            InputLabelProps={{ shrink: true }}
            sx={{ bgcolor: 'background.paper' }}
          />

          <TextField
            select
            label="Employee"
            name="employeeId"
            size="small"
            fullWidth
            value={filters.employeeId}
            onChange={onChange}
            sx={{ bgcolor: 'background.paper' }}
          >
            <MenuItem value="">All</MenuItem>
            {employeeOptions.map((emp) => (
              <MenuItem key={emp.employeeId} value={String(emp.employeeId)}>
                {emp.name}
              </MenuItem>
            ))}
          </TextField>

          <Button
            variant="contained"
            onClick={onRefresh}
            disabled={refreshing}
            startIcon={<Iconify icon="eva:refresh-fill" />}
            sx={{
              minWidth: 140,
              borderRadius: 2,
              background: 'linear-gradient(120deg, #1976d2, #0d47a1)',
              boxShadow: '0 8px 16px rgba(25,118,210,0.3)',
            }}
          >
            Refresh
          </Button>
        </Stack>
      </Stack>
    </Card>
  );
}
